import { client } from "../api/client.ts";
import { setTenantHeaderMiddleware, setupTenantIdStorage } from "@sg-protect/core";
import { useLayoutEffect, useState } from "react";

export function useSetupTenantHeaderMiddleware() {
    const [isInstalled, setIsInstalled] = useState(false);

    useLayoutEffect(() => {
        const middleware = setTenantHeaderMiddleware(setupTenantIdStorage.get, { overrideExisting: true });

        client.use(middleware);
        setIsInstalled(true);

        return () => {
            client.eject(middleware);
        };
    }, []);

    return isInstalled;
}
